<template lang="pug">
    #faelflix
        .wrapper
            h2 Fael+ o mercado exige mais de você
                img(:src="require('@images/logo/faelflix.png')", alt="Fael+ o mercado exige mais de você")
            p.subtitulo
                |Conhecimento extra a um play de distância.
                br
                |Aluno FAEL com acesso a mais de 100 cursos, pagando menos! 
            p
                |A FAELFLIX é uma plataforma de conteúdos variados, 
                |que vão colaborar tanto na vida acadêmica, como ampliar a 
                |capacitação profissional do aluno. E tudo isso pagando 
                |muito menos do que imagina.
            ul.checks
                li
                    img(:src="require('@images/icons/checkverde.png')")
                    span
                        |Cursos com grandes parcerias do mercado.
                li
                    img(:src="require('@images/icons/checkverde.png')")
                    span
                        |Contabiliza como horas de Atividades Complementares para a Graduação. 
                li
                    img(:src="require('@images/icons/checkverde.png')")
                    span
                        |Temas e conteúdos diferentes dos vistos na matriz curricular.
            div.notebook
                img(:src="require('@images/faelflix/notebook.png')")
            ul.quadrados
                li
                    div.conteudo
                        span se aprimore com
                        h3 Cursos de Gestão
                        p 
                            |Mais de 80 cursos rápidos na área de gestão, que vão ajudar 
                            |no dia-a-dia nas experiências de vendas, de negócios, 
                            |de empreendedorismo, ou qualquer ação de gestão.
                        // button(@click="$refs.aside ? $refs.aside.abrirAside() : false") saiba mais
                    div.img
                        img(:src="require('@images/faelflix/externa/letraG.png')").letra
                        img(:src="require('@images/faelflix/externa/quadradoVerdeEscuro.png')").fundo
                        img(:src="require('@images/faelflix/externa/cursoGestao.png')").icone
                        // img(:src="require('@images/faelflix/externa/consultePolo.png')").tag
                li
                    div.conteudo
                        span se prepare com
                        h3 Cursos de Extensão
                        p 
                            |Mais de 30 cursos, com 40 horas de duração, para expandir 
                            |as experiências na área de atuação 
                            |que o aluno mais se identificar.
                        // button(@click="$refs.aside ? $refs.aside.abrirAside() : false") saiba mais
                    div.img
                        img(:src="require('@images/faelflix/externa/letraE.png')").letra
                        img(:src="require('@images/faelflix/externa/quadradoVerdeEscuro.png')").fundo
                        img(:src="require('@images/faelflix/externa/cursoExtensao.png')").icone
                        // img(:src="require('@images/faelflix/externa/consultePolo.png')").tag
                li
                    div.conteudo
                        span ganhe experiência com
                        h3 Academia CEO
                        p 
                            |Conteúdos apresentados por executivos e presidentes das mais 
                            |importantes companhias do país, com experiências e práticas de gestão e liderança.
                        // button(@click="$refs.aside ? $refs.aside.abrirAside() : false") saiba mais
                    div.img
                        img(:src="require('@images/faelflix/externa/letraA.png')").letra
                        img(:src="require('@images/faelflix/externa/quadradoVerdeEscuro.png')").fundo
                        img(:src="require('@images/faelflix/externa/academiaCeo.png')").icone
                        img(:src="require('@images/faelflix/externa/emBreve.png')").tag
                li
                    div.conteudo
                        span faça seu
                        h3 Curso de Línguas
                        p 
                            |Descontos exclusivos para aprender um novo idioma. 
                            |Falar mais uma língua vai torná-lo competitivo 
                            |e o aluno pode estudar de onde e quando quiser!
                        // button(@click="$refs.aside ? $refs.aside.abrirAside() : false") saiba mais
                    div.img
                        img(:src="require('@images/faelflix/externa/letraL.png')").letra
                        img(:src="require('@images/faelflix/externa/quadradoVerdeEscuro.png')").fundo
                        img(:src="require('@images/faelflix/externa/cursoLinguas.png')").icone
                        img(:src="require('@images/faelflix/externa/emBreve.png')").tag
                li
                    div.conteudo
                        span aprenda
                        h3 Cursos de Office
                        p 
                            |Um passo necessário para a preparação de qualquer profissional. 
                            |Aulas com especialistas, que irão facilitar as atividades 
                            |realizadas nos programas do Pacote Office.
                        // button(@click="$refs.aside ? $refs.aside.abrirAside() : false") saiba mais
                    div.img
                        img(:src="require('@images/faelflix/externa/letraO.png')").letra
                        img(:src="require('@images/faelflix/externa/quadradoVerdeEscuro.png')").fundo
                        img(:src="require('@images/faelflix/externa/cursoOffice.png')").icone
                        img(:src="require('@images/faelflix/externa/emBreve.png')").tag
        Aside(ref="aside")
</template>

<script>
import Aside from '@components/Aside/Aside.vue'

export default {
    name: "faelflix",
    components: {
        Aside,
    },
}
</script>

<style lang="stylus" scoped src="@components/Faelflix/Faelflix.styl"></style>